// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function addComma(number: any, fallback = "-"): string {
  return typeof number !== "number" && typeof number !== "string"
    ? fallback
    : String(number).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
